<template>
  <div class="contents full-width-card" @click="ctaClicked">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import partners from '@/lib/partners';

export default {
  name: 'BHPartnersImageLinkCardWrapper',
  props: {
    sitterPartnerKey: {
      type: String,
      default: '',
      required: true,
    },
  },
  mounted() {
    partners.sendPartnerSegmentEvent('Partner Impression', this.sitterPartnerKey);
  },
  methods: {
    ctaClicked() {
      partners.partnerClicked(this.sitterPartnerKey);
    },
  },
};
</script>
